function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var height = function height(el, all) {
  if (!el) {
    return 0;
  }
  var style = document.defaultView.getComputedStyle(el);
  return parseFloat(parseFloat(style.marginTop) + parseFloat(style.marginBottom) + (all ? 0 : parseFloat(style.paddingTop)) + (all ? 0 : parseFloat(style.paddingBottom)) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth));
};
var heightDirective = {
  inserted: function inserted(el, data) {
    var dom = null;
    el.classList.add('v-height-box');
    var value = 0;
    var flag = false;
    if (data.value && data.value !== true) {
      value = data.value;
    }
    if (!value) {
      var parent = el.parentNode;
      var child = el;
      while (parent) {
        flag = parent.classList.contains('v-height-box');
        if (flag || parent.classList.contains('divBox') || parent.classList.contains('app-main')) {
          if (flag) {
            dom = parent;
          }
          parent = null;
        } else {
          value += height(parent);
          if (parent.classList.contains('v-height-flag')) {
            ;
            _toConsumableArray(parent.children).forEach(function (item) {
              if (item !== child) {
                value += height(item, true) + item.clientHeight;
              }
            });
          }
          child = parent;
          parent = parent.parentNode;
        }
      }
      if (value) {
        value *= -1;
      }
    }
    if (flag) {
      var style = document.defaultView.getComputedStyle(dom);
      value += -1 * parseFloat(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
    }
    el.style.height = (dom ? dom.clientHeight : window.innerHeight - 132) + value + 'px';
    el.style.overflow = 'auto';
  },
  update: function update() {
    heightDirective.inserted.apply(heightDirective, arguments);
  }
};
export default {
  install: function install(Vue) {
    Vue.directive('height', heightDirective);
    Vue.directive('height-flag', {
      inserted: function inserted(el, data) {
        el.classList.add('v-height-flag');
      }
    });
    Vue.directive('height-box', {
      inserted: function inserted(el, data) {
        el.classList.add('v-height-box');
      }
    });
  }
};